module.exports = __webpack_public_path__ + "static/media/cso.74fe4bcc.csv";